import Input from 'components/Form/Input'
import Label from 'components/Form/Label'
import Select from 'components/Form/Select'
import {
  FlexWrap,
  FormItem,
  SelectInputDiv,
  StyledInput,
} from 'components/UIComponents/FormStyles'
import React, { Fragment, useState } from 'react'
import { IsValidEmail } from 'utils/emailValidation'

const AddUserForm = ({ userRole, setCountryCodeSearch, countryCodeList }) => {
  const [countryCode, setCountryCode] = useState('91')

  const onCountryCodeChange = data => {
    setCountryCode(data)
  }

  return (
    <Fragment>
      <FlexWrap spaceBetween gap="25px">
        <FlexWrap width="49%">
          <Input
            type="text"
            width="100%"
            name={'firstName'}
            label="First Name"
            optional={'*'}
            placeholder="Eg: Vikram"
            maxLength={120}
            rules={[
              {
                validator: (_, value) => {
                  if (!value?.trim()) {
                    return Promise.reject(new Error('Please Enter First Name'))
                  } else if (
                    value.trim().length < 3 ||
                    value.trim().length > 120
                  ) {
                    return Promise.reject(
                      new Error(
                        'Please Enter Valid First Name,Minimum 3 characters , Maximum 120 characters'
                      )
                    )
                  }
                  return Promise.resolve()
                },
              },
            ]}
          />
        </FlexWrap>
        <FlexWrap width="49%">
          <Input
            type="text"
            width="100%"
            name={'lastName'}
            label="Last Name"
            optional={'*'}
            placeholder="Eg: Sharma"
            maxLength={20}
            rules={[
              {
                validator: (_, value) => {
                  if (!value?.trim()) {
                    return Promise.reject(new Error('Please Enter Last Name'))
                  } else if (value.trim().length > 30) {
                    return Promise.reject(
                      new Error(
                        'Please Enter Valid Last Name,Maximum length is 20 characters'
                      )
                    )
                  }
                  return Promise.resolve()
                },
              },
            ]}
          />
        </FlexWrap>
      </FlexWrap>

      <FormItem
        name={'adminRoleId'}
        rules={[
          {
            required: true,
            message: 'Please select Any One Role',
          },
        ]}
      >
        <Select
          OptionData={Array.isArray(userRole) ? userRole?.filter(r => r?.journey === 'CORPORATE') : []}
          label="User Role *"
          valueParam="id"
          nameParam="name"
          placeholder="Select"
          showSearch={true}
        />
      </FormItem>

      <Input
        width="100%"
        name={'email'}
        label="Email ID"
        optional={'*'}
        placeholder="Eg. vikram.sharma@plugin.com"
        rules={[
          () => ({
            validator(_, value) {
              let isValid = IsValidEmail(value)
              if (!isValid) {
                return Promise.reject(new Error(`Please Enter Valid Email`))
              }

              return Promise.resolve()
            },
          }),
        ]}
      />

      <div>
        <Label required={true}>Phone No *</Label>

        <SelectInputDiv borderleft={true} margintop="8px">
          <FormItem
            name={'countryCode'}
            rules={[
              {
                required: true,
                message: 'Please select Country Code',
              },
            ]}
          >
            <Select
              showSearch
              allowClear
              OptionData={countryCodeList}
              nameParam="phone_code"
              valueParam="phone_code"
              bordered={true}
              optionFilterProp="children"
              filterOption={true}
              onSearch={value => setCountryCodeSearch(value)}
              onSelect={() => setCountryCodeSearch('')}
              onChange={onCountryCodeChange}
              value={countryCode}
              placeholder="+91"
            />
          </FormItem>
          <StyledInput
            width="100%"
            type="tel"
            name={'phoneNumber'}
            placeholder="Eg: 9999999999"
            rules={[
              {
                min: 10,
                max: 10,
                message: 'Please enter valid phone number',
              },
              {
                required: true,
                message: 'Please enter phone number',
              },
            ]}
          />
        </SelectInputDiv>
      </div>
    </Fragment>
  )
}

export default AddUserForm
